export function copy(obj) {
  const is = determine(obj)
  let newObj = null

  if (is.object && !is.array) {
    newObj = {}

    for (const prop in obj) {
      const value = obj[prop]

      if (typeof value === 'object' && value instanceof Date === false) {
        newObj[prop] = copy(value)
      } else {
        newObj[prop] = value
      }
    }
  } else if (is.array) {
    newObj = []

    for (let i = 0; i < obj.length; ++i) {
      newObj[i] = copy(obj[i])
    }
  } else {
    return obj
  }

  return newObj
}

export function traverse(obj, path) {
  const parts = path.split('.')
  const is = determine(obj)

  let current = obj

  if (is.object && !is.array) {
    for (const part of parts) {
      current = current[part]

      if (!current) return undefined
    }
  }

  return current
}

export function determine(obj) {
  const object = isObject(obj)
  const array = Array.isArray(obj)

  return { object, array }
}

export function isObject(obj) {
  return typeof obj === 'object' && obj instanceof Date === false
}
